import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { FileInfo } from '@progress/kendo-angular-upload';

import { HelpFeedbackServiceModel, ServiceRequestResponse, User } from '../../models';
import { HelpFeedbackDataService } from './../data-services/help-feedback-data.service';

@Injectable({
    providedIn: 'root'
})
export class HelpFeedbackLogicService {

    model: HelpFeedbackServiceModel = new HelpFeedbackServiceModel();

    constructor(
        private _helpFeedbackDataService: HelpFeedbackDataService
    ) { }

    initModel(): void {
        if (this.model === undefined) {
            this.model = new HelpFeedbackServiceModel();
        }
    }

    createFormGroup(feedBackForm: UntypedFormGroup): UntypedFormGroup {
        feedBackForm = new UntypedFormGroup({
            description: new UntypedFormControl(null, [Validators.required]),
            contactMethod: new UntypedFormControl(null, [Validators.required]),
            phone: new UntypedFormControl(null)
        });
        return feedBackForm;
    }

    createFormData(feedBackForm: UntypedFormGroup, files: FileInfo[], user: User): FormData {
        const feedBackData = new FormData();
        feedBackData.append('description', (feedBackForm.value.description));
        feedBackData.append('firstName', (user.firstName));
        feedBackData.append('lastName', (user.lastName));
        feedBackData.append('userEmail', (user.email));
        feedBackData.append('callBackNumber', (feedBackForm.value.phone));
        feedBackData.append('application', "Smarts");
        feedBackData.append('contactMethod', (feedBackForm.value.contactMethod));

        if (files.length) {
            feedBackData.append('files', files[0].rawFile);
        }

        return feedBackData;
    }

    createServiceRequest(feedBackData): void {
        this.setLoadingStatus();

        this._helpFeedbackDataService.postFormData(feedBackData)
            .subscribe({
                next: (serviceResponse: ServiceRequestResponse) => {
                    this.model.serviceResponse = serviceResponse;
                },
                complete: () => {
                    this.setLoadingStatus();
                }
            });
    }

    setLoadingStatus(): void {
        this.model.responseLoading = !this.model.responseLoading;
    }

}
